import { IconButton, Select } from '@fattureincloud/fic-design-system'
import styled from 'styled-components'

export const EditMode = styled.div`
  display: flex;
  justify-content: end;
  column-gap: 12px;
  align-items: end;
  margin: 15px auto;
  max-width: 900px;
  @media print{
      display: none;
  }
  @media (max-width: 425px) {
    display: contents;
  }
`

export const EditorOptionChoice = styled.div`
  display: flex;
  column-gap: 12px;
  justify-content: end;
`

export const FavoriteRealm = styled(IconButton)`
  margin-top: 22px;
`

export const RealmChoice = styled(Select)`
  max-width: 200px;
  width: 200px;
  min-width: 200px;
`

export const ToggleLabel = styled.label`
  font-weight: bold;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  white-space: nowrap;
  align-items: center;
  cursor: pointer;
  color: black;
  @media (max-width: 425px) {
    margin-top: 10px;
  }
`
